var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskForm',{attrs:{"task":_vm.taskList,"loading":_vm.loading,"disabled":_vm.loading,"status":_vm.status},on:{"new:task":_vm.onTaskNew,"edit:task":_vm.onTaskEdit,"delete:task":_vm.onTaskDelete,"reposition:task":_vm.onTaskReposition,"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }